import { useNavigate, useParams } from 'react-router-dom'

import { MyTrainingRequestsDocument } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { FromCatalog } from 'modules/trainings/components/MyTrainings/RequestsComponent/RequestDetailSidepanelComponent/FromCatalog'
import { NewProposal } from 'modules/trainings/components/MyTrainings/RequestsComponent/RequestDetailSidepanelComponent/NewProposal'

export type Props = {
  back: string
}

const RequestDetailSidepanelPage = ({ back }: Props) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { loading: loadingRequests, data } = useQuery(MyTrainingRequestsDocument, {
    variables: { ids: [String(id)] },
  })
  const trainingRequest = data?.trainings.trainingRequestsConnection.nodes.find(
    (tr) => tr.id == String(id)
  )

  const onClose = () => {
    navigate(back)
  }

  const requestType = trainingRequest?.training?.id ? 'fromCatalog' : 'newRequest'

  if (loadingRequests || !trainingRequest) return <></>

  return (
    <Sidepanel
      width="wide"
      onClose={onClose}
      closeLabel="close"
      title={i18n.t('trainings.training_requests.my_requests.detail.title')}
      open
    >
      {requestType === 'fromCatalog' ? (
        <FromCatalog trainingRequest={trainingRequest} id={id}></FromCatalog>
      ) : (
        <NewProposal trainingRequest={trainingRequest} id={id}></NewProposal>
      )}
    </Sidepanel>
  )
}
export default RequestDetailSidepanelPage
